import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import type { IncomeSource } from 'src/pages/loan/income/data';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { toIncomeSource, type LoanIncomeDto } from './mapLoanIncome';

export interface UpdateLoanIncomeAnalysisParams {
  loanId: string;
  incomeId: string;
  analysisTables: Record<string, Record<string, Record<string, unknown>>>;
}

/**
 * Saves ONLY the analysis screen's cell state (loan_incomes.analysis_json),
 * independent of the create-form's `incomeType`/`income` -- the backend
 * accepts `analysis` on its own (see mos-mvp updateLoanIncomePayloadSchema).
 * Formula-computed cells are never sent; only what the analyst typed.
 */
const updateLoanIncomeAnalysis: MutationFunction<
  IncomeSource,
  UpdateLoanIncomeAnalysisParams
> = async ({ loanId, incomeId, analysisTables }) => {
  if (isMockServices()) {
    return await mock({
      id: incomeId,
      analysisTables,
    } as unknown as IncomeSource);
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: LoanIncomeDto;
  }>(`/loans/${loanId}/incomes/${incomeId}`, {
    method: 'PATCH',
    body: { analysis: analysisTables },
  });

  if (response.data) return toIncomeSource(response.data.data);
  throw new Error('Failed to save income analysis');
};

export default updateLoanIncomeAnalysis;
